import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';

import { TranslateModule } from '@ngx-translate/core';

import { FormioRendererI18n } from '../../../components/data-interaction/formio-renderer/formio-renderer.component';
import { PatientNameAndDob } from '../../../pages/patient-details/patient-details.component';

@Component({
  selector: 'app-task-card',
  templateUrl: './task-card.component.html',
  styleUrls: ['./task-card.component.scss'],
  imports: [CommonModule, MatIconModule, MatListModule, MatBadgeModule, TranslateModule],
  standalone: true,
})
export class TaskCardComponent {
  @Input() task: any;
  @Input() showHistory: boolean = false;
  @Input() viewContentI18n!: FormioRendererI18n;
  @Input() patientInfo!: PatientNameAndDob;
  @Input() allHistory: any[] = [];

  @Output() editTask = new EventEmitter<{
    formFileName: string;
    taskData: any;
    patientInfo: PatientNameAndDob;
    history: any[];
  }>();
}
